var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"per-page":1,"autoplay":true,"autoplayTimeout":6000,"speed":1000,"autoplayHoverPause":true,"easing":'ease',"paginationEnabled":false,"loop":true}},_vm._l((_vm.items),function(item){return _c('Slide',[_c('HomeSlide',{key:item.id,attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }